import React, {useContext, useEffect, useState} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import {makeStyles, TextField, Tooltip} from "@material-ui/core";
import {useDrag} from "react-dnd";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import TypeEntity from "../../../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import request from "../../../../../../../../Services/API/Requests";
import {SourceTypes} from "../../ToolBarUtils/ItemTypes";
import {getEmptyImage} from "react-dnd-html5-backend";
import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary} from "../../../../../../../../Utils/ExpansionPanel";
import findByString from "../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    fieldWrapper: {
        display: 'flex',
        padding: 1,
        cursor: 'move'
    },
    fieldWrapperSelected: {
        display: 'flex',
        padding: 1,
        cursor: 'move',
        background: 'rgba(66,123,255,0.2)'
    },
    labelField: {
        width: 280,
        textOverflow: "ellipsis"
    },
    fieldset: {
        padding: 2,
        border: `1px solid #b0b0b0`,
    },
    legend: {
        cursor: 'move'
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    }
}));
const Entities = () => {
    const {
        screenValues,
        onChangeDefaultFields,
        selectedComponent,
    } = useContext(ScreenDesignerContextNew);
    const classes = useStyles();
    const [entityObj, setEntityObj] = useState({id: "", schema: {}, open: false}); //{id: "", schema: {}, open: Boolean}
    const currentSelected = findByString(screenValues, selectedComponent.path);
    useEffect(() => {
        if (currentSelected && currentSelected.type === 'entity') {
            //get entities schemas
            async function fetchSchemas() {
                const entityId = currentSelected.properties ? currentSelected.properties.name : null;
                const newSchema = await getSchemas(entityId);
                setEntityObj(newSchema);
            }

            fetchSchemas();
        }
    }, [JSON.stringify(currentSelected)]);

    async function getSchemas(entityId) {
        let schema = {id: "", schema: {}, open: false};
        let isPresentSchema = entityObj.id !== entityId;
        //fetch new schema
        if (entityId !== "" && isPresentSchema) {
            const response = await request({
                url: "schema/read",
                data: {id: entityId},
                method: "POST"
            });
            schema = {id: entityId, schema: response, open: true}
        }
        //schemas.push(entityObj[schemaIndex])

        return schema;
    }

    function togglePanel() {
        setEntityObj((prevState => {
            return {
                ...prevState,
                open: !prevState.open
            }
        }))
    }


    return (
        <>
            <ExpansionPanel
                onClick={(e) => {
                    e.stopPropagation();
                    togglePanel()
                }}
                expanded={entityObj.open}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                    <span onClick={(e) => {
                        e.stopPropagation()
                    }} style={{width: '100%'}}>
                <TypeEntity
                    setValue={onChangeDefaultFields}
                    fieldStyles={{
                        withoutPadding: true,
                        width: 200
                    }}
                    showLabel={false}
                    values={screenValues}
                    labelStyles={{}}
                    field={{
                        path: `${selectedComponent.path}.properties.name`,
                        entity: 'schema',
                        schema: entityObj.schema,
                        autofocus: false //Boolean(entityObj.id === "")
                    }}
                />
                </span>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails
                    classes={{root: classes.panelDetails}}
                    onClick={e => e.stopPropagation()}
                >
                    <RenderFields schema={entityObj.schema}/>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </>
    )
};

export default Entities;

const RenderFields = ({schema}) => {
    const [selectedFields, setSelectedFields] = useState([]);

    function onDragEnd() {
        setSelectedFields([])
    }

    function onSelectionChange(source, ctrlActive) {
        //TODO if source.type = fieldArray, make something for adding in selection stack
        const setter = (prevFields) => {
            const isPresent = Boolean(prevFields.find(f => f.properties.path === source.properties.path));
            const filterPresent = (f) => f.properties.path !== source.properties.path;
            if (ctrlActive) {
                if (isPresent) {
                    return prevFields.filter(filterPresent)
                }
                return [...prevFields, source]
            } else {
                if (isPresent) {
                    //is prevFields > 1 then remove all and put only current
                    if (prevFields.length > 1) {
                        return [source]
                    }
                    return prevFields.filter(filterPresent)
                } else {
                    return [source]
                }
            }
        };
        const setterArray = (prevFields) => {
            if (ctrlActive) {
                return [...prevFields, ...source]
            } else {
                return source
            }
        };
        //collect sources in selectedFields
        if (Array.isArray(source)) {
            setSelectedFields(prevFields => setterArray(prevFields));
            return
        }
        setSelectedFields(prevFields => setter(prevFields));
    }

    return (
        <FieldContainer
            schema={schema}
            selectedFields={selectedFields}
            onSelectionChange={onSelectionChange}
            onDragEnd={onDragEnd}
            path={schema.id}
        />
    )
};

const FieldContainer = (props) => {
    const {
        schema: {properties = []} = {},
        schema,
        selectedFields,
        onSelectionChange,
        onDragEnd,
        path
    } = props;
    return (
        properties.map((field, index) => (
            field.type === 'entityEmbedded' || field.type === 'entityMixed' ? (
                <DragGroup
                    key={index}
                    field={field}
                    selectedFields={selectedFields}
                    onSelectionChange={onSelectionChange}
                    onDragEnd={onDragEnd}
                    path={path}
                />
            ) : field.type === 'object' ? (
                <DragGroup
                    key={index}
                    field={{...field, schema: {properties: field.properties || []}}}
                    selectedFields={selectedFields}
                    onSelectionChange={onSelectionChange}
                    onDragEnd={onDragEnd}
                    path={path}
                />
            ) : (
                <DragField
                    key={index}
                    field={field}
                    path={path ? `${path}.${field.name}` : `${schema.id}.${field.name}`}
                    selectedFields={selectedFields}
                    onSelectionChange={onSelectionChange}
                    onDragEnd={onDragEnd}
                />
            )

        ))
    )
};

const DragGroup = (props) => {
    const {
        field,
        selectedFields,
        onSelectionChange,
        onDragEnd,
        path
    } = props;
    const classes = useStyles();
    const [groupFields, setGroupFields] = useState([]);
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(field.label, userLanguage)
    useEffect(() => {
        const newFields = createGroup({field, path});
        setGroupFields(newFields);
    }, [field]);

    function createGroup({source = [], field, level = 1, path, arrayNestedPath}) {
        const {label, name, schema: {properties = []} = {}, isArray} = field;
        const arrayType = field.arrayType || 'vertical';
        let arrayContainer = {
            vertical: {
                type: "forEach",
                parent: name,
                properties: {
                    path: `${path}.${name}`,
                    creatable: true,
                    removable: true,
                    editScreen: ''
                },
                styles: [{width: '100%'}],
                children: []
            },
            horizontal: {
                type: "fieldArray",
                parent: name,
                properties: {
                    path: `${path}.${name}`,
                    creatable: true,
                    removable: true,
                    arrayType: 'horizontal',
                },
                styles: [{width: '100%'}],
                children: []
            }
        };
        let labelComponent = {
            type: 'label',
            properties: {label: label},
            styles: [{margin: `0 0 0 ${level * 10}px`}]
        };
        let entityMixedField = {
            field: {
                type: 'field',
                styles: [
                    {width: '300px', margin: '', fullWidth: false},
                    {width: '100px', margin: `0 0 0 ${(level + 1) * 10}px`}
                ],
                properties: {
                    type: 'entityMixed',
                    name: field.name,
                    label: field.label,
                    path: `${path}.${name}`,
                    ...field
                }
            },
            container: {
                vertical: {
                    type: 'forEach',
                    parent: name,
                    styles: [{width: '100%'}],
                    properties: {
                        path: `${path}.${name}`,
                        creatable: true,
                        removable: true,
                        editScreen: ''
                    },
                    children: []
                },
                horizontal: {
                    type: "fieldArray",
                    name: field.name,
                    properties: {
                        path: `${path}.${name}`,
                        arrayType: field.arrayType || 'vertical',
                        hidden: field.hidden
                    },
                    styles: [{width: '100%'}],
                    children: []
                }

            }
        };

        if (field.type === 'entityMixed') {
            source.push(entityMixedField.field)
        } else {
            source.push(labelComponent)
        }

        if (isArray) {
            if (field.type === 'entityMixed') {
                source.push(entityMixedField.container[arrayType])
            } else {
                source.push(arrayContainer[arrayType]) //change to forEach component
            }
        }

        properties.forEach(item => {
            if (item.type === 'entityEmbedded' || item.type === 'object') {
                createGroup({
                    source: isArray ? arrayContainer[arrayType].children : source,
                    field: {
                        ...item,
                        schema: item.type === 'entityEmbedded' ? item.schema : {properties: item.properties}
                    },
                    level: level + 1,
                    path: isArray ? arrayNestedPath ? `${arrayNestedPath}.${item.name}` : item.name : path,
                    arrayNestedPath: isArray ? arrayNestedPath ? `${arrayNestedPath}.${item.name}` : item.name : null
                });
                return
            }

            if (isArray) {
                const children = {
                    type: SourceTypes.field,
                    properties: {...item, path: arrayNestedPath ? `${arrayNestedPath}.${name}` : item.name},
                    styles: [
                        {
                            width: arrayType === 'horizontal' ? `${100 / properties.length}%` : '300px',
                            margin: '', fullWidth: false
                        },
                        {width: '100px', margin: `0 0 0 ${(level + 1) * 10}px`}
                    ]
                };
                if (field.type === 'entityMixed') {
                    entityMixedField.container[arrayType].children.push(children);
                    return
                } else {
                    arrayContainer[arrayType].children.push(children);
                }
                return
            }

            source.push({
                type: SourceTypes.field,
                properties: {
                    ...item,
                    path: arrayNestedPath ? `${arrayNestedPath}.${item.name}` : `${path}.${name}.${item.name}`
                },
                styles: [
                    {
                        width: arrayType === 'horizontal' ? `${100 / properties.length}%` : '300px',
                        fullWidth: false
                    },
                    {
                        width: '100px',
                        margin: `0 0 0 ${(level + 1) * 10}px`
                    }
                ]
            })
        });
        return source
    }

    const [_, drag, preview] = useDrag({
        item: {
            type: SourceTypes.field
        },
        begin: () => {
            let arrToMove = () => {
                if (Object.keys(selectedFields).length > 0) {
                    //merge with current group
                    return [...selectedFields, ...groupFields]
                        .filter((value, index, arr) => arr
                            .findIndex(t => t.properties.path === value.properties.path) === index)
                } else {
                    return groupFields
                }
            };
            return {
                component: arrToMove(),
                dragType: 'multiple',
                type: SourceTypes.field
            }
        }
    });
    useEffect(() => {
        preview(getEmptyImage(), {
            captureDraggingState: true
        })
    }, [preview]);
    return (
        <fieldset
            ref={drag}
            className={classes.fieldset}
            onMouseUp={(e) => onSelectionChange(groupFields, e.ctrlKey)}
        >
            <legend
                className={classes.legend}
            >
                {multiLanguageLabel}
                {field.isArray && (
                    <Tooltip title={'Array'}>
                        <MoreHorizOutlinedIcon style={{width: 20, height: 20, marginBottom: -5}}/>
                    </Tooltip>
                )}
            </legend>
            <FieldContainer
                schema={field.schema}
                selectedFields={selectedFields}
                onSelectionChange={onSelectionChange}
                onDragEnd={onDragEnd}
                path={`${path}.${field.name}`}
            />
        </fieldset>
    )
};

const DragField = ({field, path, selectedFields, onSelectionChange, onDragEnd}) => {
    const classes = useStyles();
    const source = {
        type: SourceTypes.field,
        properties: {...field, path},
        styles: [
            {width: '300px', margin: '', fullWidth: false, hideLabel: false, presentation: 'stackLabel'},
            {width: '100px', margin: ''}
        ]
    };
    const findInSelected = selectedFields.find(f => f.properties.path === path);
    const [_, drag, preview] = useDrag({
        item: {type: SourceTypes.field},
        begin: () => {
            let fields;
            if (findInSelected) {
                fields = selectedFields
            } else {
                fields = [...selectedFields, {...source}]
            }
            onSelectionChange(fields, false);
            return {
                component: fields,
                dragType: 'multiple',
                type: SourceTypes.field
            }
        },
        end: (item, monitor) => {
            if (monitor.getDropResult()) {
                onDragEnd()
            }
        },
    });
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(field.label, userLanguage)
    useEffect(() => {
        preview(getEmptyImage(), {
            captureDraggingState: true
        })
    }, [preview]);
    return (
        <div
            ref={drag}
            className={findInSelected ? classes.fieldWrapperSelected : classes.fieldWrapper}
            onMouseUp={(e) => {
                e.stopPropagation();
                onSelectionChange(source, e.ctrlKey)
            }}
        >
            <div className={classes.labelField}>{multiLanguageLabel}</div>
            <TextField variant={"outlined"} className={"form-dynamic-withoutPadding"}
                       disabled
                       value={field.name}
            />
        </div>
    )
};